export default __webpack_public_path__ + "static/media/work-in-progress.80c46736.png";